import { useInitializeMixpanel } from './_hooks';
import { PageLoading } from '@/app/ui/page';

const MixpanelProvider = ({ children }) => {
  const { isInitialized } = useInitializeMixpanel();

  if (!isInitialized) {
    return <PageLoading variant="app" />;
  }

  return children;
};

export default MixpanelProvider;
